
import { useScenario } from "../../contexts/ScenarioContext"

import RevealTable from "../RevealTable"

const OPQRSTTabContent = () => {
    const { scenario } = useScenario()

    const opqrst = Object.entries(scenario.OPQRST).map(rec => {
        return { label: rec[0], value: [rec[1]] }
    })
    return (
        <RevealTable
            title="OPQRST"
            category="opqrst"
            headings={["Type", "Value"]}
            rows={opqrst}
        />
    )
}

export default OPQRSTTabContent